export default __webpack_public_path__ + "static/media/map.1297f287.jpg";